var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#334368",
    fillRule: "evenodd",
    d: "M11.4 3.2a2.1 2.1 0 0 0-2.1 2.1v6.9h4.2V7.4h12.99v4.8h4.2V5.3a2.1 2.1 0 0 0-2.1-2.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#334368",
    fillRule: "evenodd",
    d: "M5.9 13.5a2.1 2.1 0 0 0-2.1 2.1v11.2c0 1.16.94 2.1 2.1 2.1h3.4v-4.2H8V17.7h24v7H30.7v4.2h3.4c1.16 0 2.1-.94 2.1-2.1V15.6a2.1 2.1 0 0 0-2.1-2.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#334368",
    fillRule: "evenodd",
    d: "M11.4 22.1a2.1 2.1 0 0 0-2.1 2.1v10.5c0 1.16.94 2.1 2.1 2.1h17.19c1.16 0 2.1-.94 2.1-2.1V24.2a2.1 2.1 0 0 0-2.1-2.1zm2.1 4.2h12.99v6.3H13.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrint);
export default __webpack_public_path__ + "static/media/icon-print.735e4efd22e5128184c19132119791c7.svg";
export { ForwardRef as ReactComponent };